import App from "../App";

class Constants {
  static Enterprise = 3;
  static Admin = 1;
  static True = 1;
  static False = 0;

  static BookingTabPlaceholder = `/images/property_placeholder.jpg`
  static NoImage = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjn7mbWlHkzGfpy2lawCw1ugkHUo364wFJNg&s"

  static AND = 0;
  static OR = 1;

  static Yes = "Yes";
  static No = "No";

  static TextTrue = "true";

  static STrue = "1";
  static SFalse = "0";

  static Active = 1;
  static Trash = 2;
  static Deactive = 3;
  static AlwaysActive = 4;
  static SpecialField = 5;

  static TextActive = "Active";
  static TextTrash = "Trash";
  static TextDeactive = "Deactive";
  static TextAlwaysActive = "Always Active";

  static UserName = "username";
  static UserNo = 10;

  //Local DB
  static LoggedIn = "logged-in";
  static LoggedInUser = "logged-in-user";
  static Token = "token";
  static System = "systm";
  static Model = "model";
  static ModulePermission = "module_permission";
  static Countries = "countries";
  static States = "states";
  static Cities = "cities";
  static Products = "products";
  static Views = "views";
  static Properties = "property";
  static Areas = "areas";
  static Towers = "towers";
  static Rooms = "rooms";
  static Actions = "actions";
  static FieldList = "field-list";
  static CloudCalling = "cloud-calling";
  static CurrentViews = "current-views";
  static ProjectInventory = "module-project-inventory";
  static LiveLocationTrackingModule = 'module~live_location_tracking'

  static Password = "password";
  static Text = "text";
  static TextArea = "textarea";
  static Number = "number";
  static Double = "double";
  static Decimal = "decimal";
  static Select = "select";
  static MultiSelect = "multiselect";
  static Date = "date";
  static DateTime = "datetime";
  static Address = "address";
  static Street = "street";
  static Tstreet = "Street";
  static City = "city";
  static Tcity = "City";
  static State = "state";
  static Tstate = "State";
  static Country = "country";
  static Tcountry = "Country";
  static Pin = "pin";
  static Tpin = "Pin";
  static MultiValue = "multi_value";
  static SinglePhone = "single_phone";
  static Phone = "phone";
  static Email = "email";
  static Web = "website";
  static Toggle = "toggle";
  static Files = "files";
  static Complete = "complete";
  static Module = "module";
  static Duration = "duration";
  static MainModel = "main_model";
  static Location = "location";
  static Audio = "audio";

  static Status = "status";
  static T_Product = "product";

  static Mandatory = "+";
  static NonMandatory = "*";

  static Opt = "~";
  static Hhn = "-";
  static Back = "/";
  static Comn = ",";
  static Empty = "";
  static SingleQuote = "'";

  static NetWorkFailure = 1;
  static Success200 = 200;
  static Redirect302 = 302;
  static Invalid400 = 400;
  static UnAuth401 = 401;
  static NotFound404 = 404;
  static Conflict409 = 409;

  static ProcessAPI = (res, success, error) => {
    if (res.status === Constants.Success200)
      res.json().then((result) => success(result));
    else if (res.status === Constants.Redirect302) App.onPay();
    else if (res.status === Constants.Invalid400 || res.status === Constants.Conflict409) {
      res.text().then((err) => {
        App.onFail(err);
        if (error) {
          error(err);
        }
      });
    } else if (res.status === Constants.NotFound404) {
      const err = { message: "Link not found" };
      App.onFail(err);
      if (error) {
        error(err);
      }
    } else if (res.status === Constants.UnAuth401) {
      App.onLogout();
    } else {
      throw res;
    }
  };

  static PermView = 0;
  static PermAdd = 1;
  static PermUpdate = 2;
  static PermDelete = 3;
  static PermRestricAcc = 4;
  static PermImport = 5;
  static PermExport = 6;
  static PermMassUpdate = 7;
  static PermMassEmail = 8;
  static PermMassSMS = 9;
  static HideAllContact = 10;
  static HideOtherContact = 11;
  static PermInnerListRestrict = 12;
  static PermListFieldRestrict = 13;
  static SearchOnMobile = 14;
  static PermMassDelete = 15;
  static PermAllowPermission = 16;
  static PermMassWhatsApp = 17;
  static PermLeadPreviewRestrict = 18;

  static PermLeadSearchRestrictedView = 0;
  static PermLeadSearchAddCall = 1;
  static PermLeadSearchAddMeet = 2;

  static Role = "role";
  static User = "user";

  static ListLead = "list-lead";
  static ListContact = "list-contact";
  static ListSales = "list-sales";
  static ListCustomer = "list-customer";
  static ListCall = "list-call";
  static ListMeeting = "list-meeting";
  static ListInstallment = "list-installment";
  static ListProperty = "list-property";
  static ListProject = "list-project";
  static ListAttendance = "list-attendance";
  static ListNote = "list-note";

  static CheckinStat = "checkin-status";

  static KeyRestricted = "responsible_person";
  static KeyFeedback = "feedback";

  static Lead = 1;
  static Contact = 2;
  static SalesOrder = 3;
  static TextSalesOrder = "sales_order";
  static Customer = 4;
  static Call = 5;
  static TextCall = "call";
  static Meeting = 6;
  static Product = 9;
  static Report = 26;
  static Installment = 21;
  static Property = 49;
  static Project = 50;
  static Attendance = 52;
  static Tower = 53;
  static Note = 61;
  static ColdData = 81;

  // Views - List or Kanban
  static View = "view";
  static KanbanViews = "kanban-view";
  static CurrentKanbanView = "current-kanban-view";

  static ListView = 'list-view';
  static KanbanView = 'kanban-view';

  static Webhook = 1;
  static IndiaMart = 2;
  static Ozonetel = 3;
  static Facebook = 4;
  static Acre99 = 6;
  static Magicbricks = 7;
  static Housing = 8;
  static RealestateIndia = 9;
  static Mcube = 10;
  static Justdial = 11;
  static WhatsApp = 12;
  static TradeIndia = 13;
  static Sulekha = 14;
  static ExportIndia = 15;
  static Exotel = 16;
  static TataTeleservices = 17;
  static Interakt = 18;
  static AiSensy = 19;
  static Instgram = 20;
  static LinkedIn = 21;
  static Wati = 22;
  static DoubleTick = 23;
  static MyOperator = 24;
  static TeleCMI = 25;
  static Wordpress = 26;
  static Shopify = 27;
  static Razorpay = 28;
  static Payu = 29;
  static Stripe = 30;
  static VerifyUser = 31;
  static Digio = 32;
  static MailChimp = 33;
  static Brevo = 34;
  static Sendgrid = 35;
  static Microsoft365 = 36;
  static Quickbook = 37;
  static Gupshup = 38;
  static TextLocal = 39;
  static MsgClub = 40;
  static GoogleAds = 41;
  static Forms = 42;
  static BlueDart = 43;
  static Fedex = 44;
  static EcomExpress = 45;
  static AllCargo = 46;
  static Vrl = 47;
  static Dhl = 48;
  static Dtdc = 49;
  static IndianPost = 50;
  static Gmail = 51;
  static DaveSoft = 52;

  static CallStatusDialerCloudCall = 3;

  static Hit = 1;
  static Fetch = 2;

  static ResponsiblePerson = "responsible_person";

  static LeadTheme = "lead-theme";

  static ReportFilter = "report-filter-";

  static replaceAll = (str, find, replace) => {
    if (str && typeof str == "string") {
      let offset = 0;
      let indx = str.indexOf(find, offset);
      while (indx !== -1) {
        if (replace !== "") {
          if (indx !== 0) {
            str =
              str.substring(0, indx) +
              replace +
              str.substring(indx + find.length);
            offset = indx + replace.length + 1;
          } else {
            str = replace + str.substring(indx + find.length);
            offset = indx + replace.length;
          }
        } else {
          str = str.replace(find, replace);
        }
        indx = str.indexOf(find, offset);
      }
    }
    return str;
  };

  static PackageStarter = 1;
  static PackageGrowth = 2;
  static PackageEnterprise = 3;

  static Months = [
    { label: "Jan", value: "1" },
    { label: "Feb", value: "2" },
    { label: "Mar", value: "3" },
    { label: "Apr", value: "4" },
    { label: "May", value: "5" },
    { label: "Jun", value: "6" },
    { label: "Jul", value: "7" },
    { label: "Aug", value: "8" },
    { label: "Sept", value: "9" },
    { label: "Oct", value: "10" },
    { label: "Nov", value: "11" },
    { label: "Dec", value: "12" },
  ];

  static FixedreportsList = [
    {
      title: "General Reports",
      reports: [
        { name: "Daily Sales Report", link: "/dailySalesReport" },
        {
          name: "Individual Performance Report",
          link: "/individualSalesReport",
        },
        {
          name: "Lead To Site Visit Ratio Month Wise",
          link: "/leadToSiteVisitRatioMonthWise",
        },
        {
          name: "Lead To Site Visit Ratio Sales Executive Wise",
          link: "/leadToSiteVisitRatioSalesExecutiveWise",
        },
        {
          name: "Consolidated Activity Report ",
          link: "/consolidatedActivityReport",
        },
        {
          name: "Sales Executive Performance Report 2",
          link: "/salesExecutivePerformanceReport2",
        },
      ],
    },
    {
      title: "Lead Reports",
      reports: [
        { name: "Lead Report ", link: "/leadReport" },
        { name: "Lead By Source Report ", link: "/LeadBySourceReport" },
        { name: "Lead By Status Report ", link: "/LeadByStatusReport" },
        { name: "Lead By Project Report ", link: "/LeadByProjectReport" },
        { name: " Lead By sales executive ", link: "/leadBySalesPerson" },
        {
          name: " Lead Conversion by sales executive ",
          link: "/LeadBySalesExecutiveReport",
        },
        {
          name: "Lead Conversion By Source Report ",
          link: "/LeadConversionBySource",
        },
        {
          name: "Lead Status by Sales person ",
          link: "/leadStatusBySalesPerson",
        },
        {
          name: "Lead By Source by Sales person ",
          link: "/leadBySourceBySalesPerson",
        },
        {
          name: "Lead Untouched By Sales Executive",
          link: "/leadsUntouchedBySalesExecutive",
        },
        {
          name: "Lead By Type By Sales Person",
          link: "/LeadByTypeBySalesPerson",
        },
        {
          name: "Monthly Leads By Source Report",
          link: "/monthlyLeadsBySourceReport",
        },
        {
          name: "Monthly Leads By Sales Executive Report",
          link: "/monthlyLeadsBySalesExecutiveReport",
        },
      ],
    },
    {
      title: "Call Reports",
      reports: [
        { name: "Call Report ", link: "/callReport" },
        {
          name: "Call Report By Sales Executive",
          link: "/callFeedbackBySalespersonwithLead",
        },
        { name: "Call Talktime Report", link: "/callTalkTimeReport" },
        { name: "Completed Call Report", link: "/callCompleteReport" },
        { name: "Pending Call Report", link: "/callPendingReport" },
        { name: "Call Count By Sales Person Report", link: "/callCountReport" },
        { name: "Missed call report", link: "/missedCallReport" },
        {
          name: "Call Feedback By sales Person",
          link: "/callFeedbackBySalesperson",
        },
        {
          name: "Call Feedback By sales Person (Lead and Call Combine )",
          link: "/leadcallFeedbackBySalesperson",
        },
        {
          name: "Call Feedback By Project (Lead and Call Combine )",
          link: "/leadcallFeedbackByProject",
        },
        {
          name: "Call Status Report",
          link: "/callStatusReport",
        },
        {
          name: "Hourly Call Report",
          link: "/callStatusByHourReport",
        },
      ],
    },
    {
      title: "Site Visit Reports",
      reports: [
        { name: "Site Visit Report ", link: "/siteVisitReport" },
        { name: "Monthly Site Visit Report", link: "/monthlySiteVisitReport" },
        {
          name: "Monthly Site Visit By Feedback Report",
          link: "/monthlySiteVisitByFeedbackReport",
        },
        // { name: "Monthly Site Visit By  Source Report", link: "/MonthlySiteVisitBySourceReport" },
        {
          name: "Monthly Site Visit By SalesExecutive Report",
          link: "/MonthlySiteVisitBySalesExecutiveReport",
        },
        {
          name: "Site Visit By Sales Executive Report",
          link: "/siteVisitBySalesExecutiveReport",
        },
        {
          name: "Site Visit By Feedback By Sales Person",
          link: "/siteVisitFeedbackBySalesPerson",
        },
      ],
    },
    {
      title: "Booking Reports",
      reports: [
        { name: "Booking Report ", link: "/SalesOrderReport" },
        { name: "Booking By Sales Person", link: "/bookingBySalesExecutive" },
        { name: "Booking By Project", link: "/bookingByProject" },
        { name: "Booking By Source", link: "/bookingBySource" },
        {
          name: "Booking By Source By Project",
          link: "/bookingBySourceByProject",
        },
        {
          name: "Revenue By Sales Executive ",
          link: "/revenueBySalesExecutive",
        },
        { name: "Monthly Sales Report", link: "/monthlySalesReport" },
        {
          name: "Monthly Sales Report By Sales Executive",
          link: "/monthlySalesReportbySalesExecutive",
        },
      ],
    },
    {
      title: "Attendance Reports",
      reports: [
        {
          name: "Monthly Attendance By Sales Person Report",
          link: "/monthlyAttendanceBySalesPersonReport",
        },
         {
          name: "Daily Attendance By Sales Executive",
          link: "/DailyAttendanceBySalesPersonReport",
        },
      ],
    },
    {
      title: 'Property Reports', reports: []
    },
    {
      title: "Project Reports",
      reports: [{ name: "Project By Sales Report", link: "/projectBySales" }],
    },
  ];

  static SelectValues = (value) => {
    return value && value.length > 2
      ? value.substring(1, value.length - 1).split(Constants.Opt)
      : [];
  };

  static FileType = [
    ["image/jpeg", "image/png", "image/svg+xml"],
    ["video/mp4", "video/mkv", "video/webm", "video/3gp"],
    [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ],
  ];

  static FileUploadType = [
    ["jpg", "jpeg", "png", "svg+xml"],
    ["mp4", "mkv", "webm", "3gp"],
    [
      "pdf",
      "msword",
      "vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
      "vnd.ms-excel",
      "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "csv",
      "vnd.ms-powerpoint",
      "vnd.openxmlformats-officedocument.presentationml.presentation",
    ]
  ];

  static VIEW_OPTIONS = [
    { value: "list-view", label: "List View"}, 
    { value:"kanban-view", label: "Kanban View" }
  ]
}

export default Constants;
